export function uniqueArray<T>(arr: Array<T>): Array<T> {
  const set = new Set(arr.map(it => JSON.stringify(it)))
  return Array.from(set).map(it => JSON.parse(it))
}
